import { render, staticRenderFns } from "./EquipesProfissionalDataTable.vue?vue&type=template&id=580b2cb7&scoped=true"
import script from "./EquipesProfissionalDataTable.vue?vue&type=script&lang=ts"
export * from "./EquipesProfissionalDataTable.vue?vue&type=script&lang=ts"
import style0 from "./EquipesProfissionalDataTable.vue?vue&type=style&index=0&id=580b2cb7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580b2cb7",
  null
  
)

export default component.exports